import { render, staticRenderFns } from "./EnergyLabelButton.vue?vue&type=template&id=1bca6b3c&"
import script from "./EnergyLabelButton.vue?vue&type=script&lang=js&"
export * from "./EnergyLabelButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Misha\\Documents\\GitHub\\energy_label_plugin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bca6b3c')) {
      api.createRecord('1bca6b3c', component.options)
    } else {
      api.reload('1bca6b3c', component.options)
    }
    module.hot.accept("./EnergyLabelButton.vue?vue&type=template&id=1bca6b3c&", function () {
      api.rerender('1bca6b3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/EnergyLabelButton.vue"
export default component.exports